<script>
  import { useResolve } from "svelte-navigator";
  import { _ } from 'svelte-i18n'

  import {styleVars, formatDate} from '/helper'
  import Card from '/components/Atoms/Card.svelte'
  import IconList from '/components/Icons/IconList.svelte'
  import Link from '/components/Atoms/Link'

  export let entries

  const maxEntries = 4
  const resolve = useResolve();

</script>

<Card bgColorKey="white" paddingStyle="list">
  <div class="container">
    <h3 class="title">
      {$_("widgets.news.title")}
    </h3>
    {#each entries as entry, i}
      {#if i < maxEntries }
        <span class="entry">
          <Link to={ resolve("/news/" + entry.slug) } >
            {#if entry.postDate}
              <div class="date">
                {formatDate(new Date(entry.postDate), 'event-day-month-year')}
              </div>
            {/if}
            {entry.title}
          </Link>
        </span>
        {/if}
    {/each}
    <Link to={ resolve("/news/") } >
      <span class="more">
        <span class="text">{$_("widgets.news.show_more")}</span>
        <IconList class="icon"/>
      </span>
    </Link>
  </div>
</Card>

<style lang="scss">
  .container {
  }
  .title, .entry {
    margin-bottom: 22px;
    @include media-small {
      margin-bottom: 15px;
    }
  }
  .title {
    @include typo-grotesk-title-captions-20;
    color: $color-red;
  }
  .entry {
    @include typo-serif-text-28;
    display: block;
    white-space: pre-line;
  }

  .date {
    @include typo-serif-small-caps-28;
  }

  .more {
    @include typo-grotesk-title-captions-20;
    color: $color-red;
    display: flex;
    padding-top: 10px;
    justify-content: space-between;
    .icon {
      
    }
  }
</style>